module.exports = __webpack_public_path__ + "media/images/download-3acfbb62de086661a3f168eb2ef5f5f0.svg";